import RoomElement from './RoomElement'
import game from '../../Game/GameInstance'
import PersonIndicator from '../PersonIndicator'
import UrlExecutor from '../../Api/UrlExecutor'
import colorSchemeRepository from '../../Images/ColorSchemeRepository'

let radius = 15;
let speakerSize = 50;
let speakerMargin = -10;

let debug = false;

export default class StageRenderer extends RoomElement
{

  constructor() {

    super(...arguments);

    switch(this.room.size) {
      case 'L':
        this.maxSpeakers = 7;
        break;
      case 'M':
        this.maxSpeakers = 4;
        break;
      case 'S':
        this.maxSpeakers = 2;
        break;
    }

    this.overflowElement = new PersonIndicator(speakerSize, []);

  }


  render(ctx) {

    let stage = this.room.getStage();
    if (!stage) {
      return;
    }

    this.renderBackground(ctx, stage);

    this.renderSpeakers(ctx, stage);

    if (debug) {
      let box = this.getSpeakerBox();
      this.debugBox(ctx, box);
    }


  }

  renderBackground(ctx, stage) {

    ctx.beginPath();

    ctx.moveTo(this.scale(radius), this.scale(0));

    // top
    ctx.lineTo(this.scale(this.roomWidth() - radius), this.scale(0));
    ctx.quadraticCurveTo(this.scale(this.roomWidth()), this.scale(0), this.scale(this.roomWidth()), this.scale(radius));

    // right
    ctx.lineTo(this.scale(this.roomWidth()), this.scale(stage.height));

    // bottom
    ctx.quadraticCurveTo(this.scale(this.roomWidth()/ 2), this.scale(stage.height + stage.arcHeight), this.scale(0), this.scale(stage.height));

    // left
    ctx.lineTo(this.scale(0), this.scale(radius));
    ctx.quadraticCurveTo( this.scale(0), this.scale(0), this.scale(radius), this.scale(0));

    ctx.fillStyle = colorSchemeRepository.get('roomStageBackground');
    ctx.fill();

  }

  renderSpeakers(ctx) {

    this.overflowElement.setScale(this.room.zoom);

    let box = this.getSpeakerBox();

    let speakers = this.getSpeakers();

    let x = box.x;
    let y = box.y;

    this.room.hoverMask.remove(new RegExp(/speaker-\d+/));

    let hasOverflow = false;
    let speakerCount = speakers.length;
    if (speakerCount === this.maxSpeakers) {
      speakerCount = this.maxSpeakers;
    }
    else{
      if (speakerCount > this.maxSpeakers) {
        speakerCount = this.maxSpeakers - 1;
        hasOverflow = true;
      }
    }
    for (let i = 0; i < speakerCount; i++) {
      speakers[i].model.setScale(this.room.zoom);

      speakers[i].model.size = (speakerSize);
      speakers[i].model.width = (speakerSize + 4);
      speakers[i].model.height = (speakerSize + 4);
      speakers[i].model.x = x;

      speakers[i].model.render(speakers[i].model.ctx);

      ctx.drawImage(speakers[i].model.ctx.canvas, this.scale(x), this.scale(y));

      this.room.hoverMask
        .add('speaker-' + i, x, y, speakerSize + (i < speakerCount - 1 ? speakerMargin : 0), speakerSize)
        .over(() => {
          game.setToolTipText(this.room.x + speakers[i].model.x + speakerSize / 2 + 2, this.room.y + y + speakerSize + 4, speakers[i].model.getName(), false);
        })
        .out(() => {
          game.setToolTipText(null);
        })
        .click(() => {
          UrlExecutor.execute(speakers[i].model.data.url);
        });

      x += speakerSize + speakerMargin;


    }

    if (hasOverflow) {

      this.overflowElement.setCount(speakers.length - this.maxSpeakers  + 1);
      this.overflowElement.render(this.overflowElement.ctx);
      ctx.drawImage(this.overflowElement.ctx.canvas, this.scale(x), this.scale(y));


      this.room.hoverMask
        .add('speaker-overflow', x, y, speakerSize, speakerSize)
        .over(() => {

          this.room.hoverMask.add('speaker-dropdown', x - (game.hoverNameList.width - speakerSize) / 2, y, game.hoverNameList.width, speakerSize + game.hoverNameList.height).out(() => {

            game.showHoverNameList(null);
            this.room.hoverMask.remove(/speaker-dropdown/);

          })
          game.showHoverNameList(this.room.x + x + speakerSize / 2 + 2, this.room.y + y + speakerSize + 4, this.getModels(speakers.slice(this.maxSpeakers - 1)));

        });

    }

  }


  getSpeakerBox() {

    let x = 0;
    let y = 65;
    let width = 0;
    let height = speakerSize;

    let speakers = this.getSpeakers();

    let speakerCount = speakers.length;
    if (speakerCount > this.maxSpeakers) {
      speakerCount = this.maxSpeakers;
    }

    if (speakerCount > 0) {
      width = (speakerSize + speakerMargin) * speakerCount - speakerMargin;
      x = (this.roomWidth() - width) / 2;
    }

    return  {
      height,
      width,
      x,
      y
    }
  }

  getModels(speakers) {

    let res = [];
    speakers.forEach(speaker => {
      res.push(speaker.model);
    });
    return res;

  }

  garbageCollect() {

    if (this.overflowElement) {
      this.overflowElement.garbageCollect();
    }

  }

}
